export class MicroappQuitListFilter{
    general: string;
    expire: string;
    status: number;
}